import Link from 'next/link'
import { ROUTES } from '../../../constants'
import { useAuth } from '../../../contexts/auth'

export default function CTACards() {
  const [{ userDetails }] = useAuth()
  return (
    <>
      <div className='wrapper flex justifyBetween'>
        <div className='aspectRatioBox'>
          <Link legacyBehavior href={ROUTES.Sell}>
            <a>
              <div className='cardWrapper flex alignEnd'>
                <img
                  className='cardBackground'
                  src='/images/car-interior.png'
                  alt='car interior'
                  width='670'
                  height='360'
                />
                <div className='textWrapper'>
                  <h3>Sell or trade your vehicle</h3>
                  <p>Get started</p>
                </div>
              </div>
            </a>
          </Link>
        </div>
        {userDetails.verified === false && (
          <div className='aspectRatioBox'>
            <Link legacyBehavior href={ROUTES.GetVerified}>
              <a>
                <div className='cardWrapper flex alignEnd'>
                  <img
                    className='cardBackground'
                    src='/images/person-holding-phone.png'
                    alt='person holding smartphone'
                    width='670'
                    height='360'
                  />
                  <div className='textWrapper'>
                    <h3>Become a verified user</h3>
                    <p>Start Verification</p>
                  </div>
                </div>
              </a>
            </Link>
          </div>
        )}
      </div>

      <style jsx>{`
        .wrapper {
          width: 100%;
          margin: 5rem 0 0;
          flex-wrap: wrap;
        }

        .aspectRatioBox {
          padding: calc(360 / 670 * ((100% - 3.7rem) / 2)) 0 0 0;
          width: calc((100% - 3.7rem) / 2);
          min-width: 5.2rem;
          height: 0;
          position: relative;
        }

        .cardBackground {
          position: absolute;
          width: 100%;
          object-fit: cover;
          z-index: -1;
        }

        .cardWrapper {
          position: absolute;
          width: 100%;
          height: 100%;
          top: 0;
          overflow: hidden;
          border-radius: 1rem;
        }

        .textWrapper {
          padding: 3.2rem 5rem;
          width: 100%;
          background: linear-gradient(0deg, #000 -25%, transparent 100%);
          z-index: 1;

          h3 {
            color: #fff;
            line-height: 4.7rem;
            font-weight: 700;
            font-size: 3.5rem;
          }

          p {
            color: #fff;
            line-height: 3rem;
            font-size: 2.2rem;
          }
        }

        @media (max-width: 1495px) {
          .wrapper {
            flex-direction: column;
          }

          .aspectRatioBox {
            padding: calc(360 / 670 * 100%) 0 0;
            width: 100%;
          }

          .aspectRatioBox + .aspectRatioBox {
            margin: 3.6rem 0 0;
          }
        }
      `}</style>
    </>
  )
}
